import Enumerator from './Enumerator';

export const zoningOptions = ['none', 'commercial', 'industrial', 'residential', 'rural'];

export class ZoningOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'commercial';
        break;
      case '2':
        correctOption = 'residential';
        break;
      case '3':
        correctOption = 'rural';
        break;
      case '4':
        correctOption = 'industrial';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ZoningOption.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  commercial: {
    get title() {
      return 'Commercial';
    }
  },
  industrial: {
    get title() {
      return 'Industrial';
    }
  },
  residential: {
    get title() {
      return 'Residential';
    }
  },
  rural: {
    get title() {
      return 'Rural';
    }
  }
});

export default {
  zoningOptions,
  ZoningOption
};
